import { getErrorStatus } from "@/utils/httpStatus"

export const TYPESENSE_REQUEST_TIMEOUT_MS = 5000

export function isTypesense401(error: unknown): boolean {
  return getErrorStatus(error) === 401
}

/**
 * Runs `operation` and, in the browser only, retries it once with a refreshed key
 * on a 401 — the key has expired in a tab left open past its 1h lifetime. On the
 * server the key was fetched during the same request, so a 401 means the parent
 * key is missing or wrong in Typesense; a retry cannot fix that and would only
 * double the request volume during an incident.
 */
export async function withTypesenseKeyRetry<T>(
  operation: (key: string) => Promise<T>,
  currentKey: string,
  refreshKey: () => Promise<string>,
): Promise<T> {
  try {
    return await operation(currentKey)
  }
  catch (error) {
    if (import.meta.server || !isTypesense401(error))
      throw error

    const newKey = await refreshKey()
    return operation(newKey)
  }
}
